import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_2 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M10.05 13.95L3.57495 11.325C3.35828 11.2417 3.19995 11.1125 3.09995 10.9375C2.99995 10.7625 2.94995 10.5833 2.94995 10.4C2.94995 10.2167 3.00412 10.0375 3.11245 9.86249C3.22078 9.68749 3.38328 9.55833 3.59995 9.47499L18.95 3.77499C19.15 3.69166 19.3416 3.67499 19.525 3.72499C19.7083 3.77499 19.8666 3.86666 20 3.99999C20.1333 4.13333 20.225 4.29166 20.275 4.47499C20.325 4.65833 20.3083 4.84999 20.225 5.04999L14.525 20.4C14.4416 20.6167 14.3125 20.7792 14.1375 20.8875C13.9625 20.9958 13.7833 21.05 13.6 21.05C13.4166 21.05 13.2375 21 13.0625 20.9C12.8875 20.8 12.7583 20.6417 12.675 20.425L10.05 13.95ZM13.55 17.3L17.6 6.39999L6.69995 10.45L11.6 12.4L13.55 17.3Z",
      fill: $props.color
    }, null, 8, _hoisted_2)
  ]))
}